import { useCallback } from 'react';
import { BiometricType, useDownloadBiometricDataMutation } from 'services/biometricsService';

const CSV_FILE_NAMES: Record<BiometricType, string> = {
  blood_glucose: 'bio_history_blood_sugar.csv',
  blood_pressure: 'bio_history_blood_pressure.csv',
  weight: 'bio_history_weight.csv',
};

const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const useBiometricDownload = (biometricType: BiometricType, userId: number) => {
  const [downloadHistory, { isLoading, isError }] = useDownloadBiometricDataMutation();

  const download = useCallback(async () => {
    try {
      const blob = await downloadHistory({ biometricType, userId }).unwrap();
      saveBlob(blob, CSV_FILE_NAMES[biometricType]);
    } catch {
      // Surfaced through `isError`.
    }
  }, [downloadHistory, biometricType, userId]);

  return { download, isDownloading: isLoading, isError };
};
